module.exports = __webpack_public_path__ + "img/HC3010-01.1f5c77d9.jpg";